module.exports = __webpack_public_path__ + "static/media/CircuralInactive.b67d2fc1.svg";